/**
 * Form slice for importing reviews (brand vs company scope). Extends independently of `ReviewFormFieldsType`.
 */

import type {UploadFile} from 'antd';
import type {RcFile} from 'antd/es/upload';

import {ReviewDataTagType} from '../../../../../service/reviews/reviews-type';
import type {ReviewEntityScopeEnum} from '../../review-brand-company-scope-card/review-brand-company-scope-card.types';

export {ReviewEntityScopeEnum as ImportReviewsEntityScopeEnum} from '../../review-brand-company-scope-card/review-brand-company-scope-card.types';

export enum ImportReviewsFormFieldNamesEnum {
    entityScope = 'entityScope',
    brand = 'brand',
    company = 'company',
    tags = 'tags',
    reviewsFile = 'reviewsFile',
}

export type ImportReviewsFormFieldsType = {
    [ImportReviewsFormFieldNamesEnum.entityScope]: ReviewEntityScopeEnum;
    [ImportReviewsFormFieldNamesEnum.brand]?: number;
    [ImportReviewsFormFieldNamesEnum.company]?: number;
    [ImportReviewsFormFieldNamesEnum.tags]?: Array<ReviewDataTagType>;
    [ImportReviewsFormFieldNamesEnum.reviewsFile]?: Array<UploadFile<RcFile>>;
};
